import { format } from 'date-fns/format'

import { DATEFORMAT_SHORT } from '@/defs/date'

import { parseUnknownDate } from './parseUnknownDate'

export const formatDate = (date: string, formatStr: string = DATEFORMAT_SHORT) => {
  const parsed = parseUnknownDate(date)
  if (!parsed) return
  return format(parsed, formatStr)
}
